module.exports = __webpack_public_path__ + "static/media/que-faire-en-cas-vol.1dfe5cc2.png";